import { IModalL10n } from '../../interface/IModal';
import { ko, zh, ja, en, th, ru, id, ar } from './lang';

export const modalL10n: IModalL10n = { ko, zh, ja, en, th, ru, id, ar };
